import React from 'react'
import { ConfigProvider } from 'antd'
import { IntlProvider } from 'react-intl'

import english from './locales/en-US'
import korean from './locales/ko-KR'

const locales = {
  'en-US': english,
  'ko-KR': korean,
}

const Localization = ({ children }) => {
  // const currentLocale = locales[process.env.REACT_APP_LOCALE]
  const currentLocale = locales[process.env.REACT_APP_LOCALE]
  return (
    <ConfigProvider locale={currentLocale.localeAntd}>
      <IntlProvider locale={currentLocale.locale} messages={currentLocale.messages}>
        {children}
      </IntlProvider>
    </ConfigProvider>
  )
}

export default Localization
